import BubbleMap from "./bubble-maps/BubbleMap.vue";
import GoogleMap from "./google-maps/GoogleMap.vue";
import LeafletMaps from "./leaflet-maps/LeafletMap.vue";
import LineMap from "./line-maps/LineMap.vue"
import { yandexMap, ymapMarker } from "./yandex-maps/index.js";


export {
    BubbleMap,
    GoogleMap,
    LeafletMaps,
    LineMap,
    yandexMap,
    ymapMarker
}